var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67089 14.963C3.95695 13.9692 3.59998 13.4723 3.59998 11.9969C3.59998 10.5214 3.95695 10.0245 4.67089 9.03077C6.09643 7.04648 8.48719 4.79688 12 4.79688C15.5128 4.79688 17.9035 7.04648 19.3291 9.03077C20.043 10.0245 20.4 10.5214 20.4 11.9969C20.4 13.4723 20.043 13.9692 19.3291 14.963C17.9035 16.9473 15.5128 19.1969 12 19.1969C8.48719 19.1969 6.09643 16.9473 4.67089 14.963Z",
    stroke: "#1552E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 12.0016C14.4 13.327 13.3255 14.4016 12 14.4016C10.6745 14.4016 9.59998 13.327 9.59998 12.0016C9.59998 10.6761 10.6745 9.60156 12 9.60156C13.3255 9.60156 14.4 10.6761 14.4 12.0016Z",
    stroke: "#1552E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEye);
export default __webpack_public_path__ + "static/media/BlueEye.a9fa2dc5b040593f4d9e95362c0389cb.svg";
export { ForwardRef as ReactComponent };